export const SERVER = "https://www.terradata.com.br/";

export const LOGIN = SERVER + 'api/auth/login.php';

export const USERS_LIST = SERVER + 'api/user/list.php';
export const USERS_CREATE = SERVER + 'api/user/create.php';
export const USERS_UPDATE = SERVER + 'api/user/update.php';
export const USERS_DELETE = SERVER + 'api/user/delete.php';

export const LICENSES_LIST = SERVER + 'api/license/list.php';
export const LICENSES_CREATE = SERVER + 'api/license/create.php';
export const LICENSES_UPDATE = SERVER + 'api/license/update.php';
export const LICENSES_DELETE = SERVER + 'api/license/delete.php';

export const USER_TYPES_LIST = SERVER + 'api/user-type/list.php';
export const USER_STATUS_LIST = SERVER + 'api/user-status/list.php';

export const LICENSE_TYPES_LIST = SERVER + 'api/license-type/list.php';
export const LICENSE_STATUS_LIST = SERVER + 'api/license-status/list.php';

export const PROFILE_CREATE = SERVER + 'api/profile/create.php';
export const PROFILE_UPDATE = SERVER + 'api/profile/update.php';